module.exports = __webpack_public_path__ + "static/media/report_performance.ec441b00.svg";